angular
    .module('app')
    .component('campaignsAdd', {
        templateUrl: '/templates/pages/campaigns/campaignsAdd/campaignsAdd.html',
        controller: 'CampaignsAddController',
        controllerAs: 'vm',
    });